export const SOURCES_ROUTE = "/sources";
export const HOME_ROUTE = "/sources";
export const TAGS_ROUTE = "/tags";
export const INTERESTING_THINGS_ROUTE = "/things";
export const NEW_CHAT_ROUTE = "/new-chat";
export const SPOTIFY_TOP_TRACKS_ROUTE = "/spotify-top-tracks";
export const SPOTIFY_OAUTH_LOGIN_ROUTE = "/spotify-login";
export const SPOTIFY_OAUTH_REDIRECT_ROUTE = "/spotify-redirect";
export const DEBUG_PAGE_ROUTE = "/debug";
export const LOGIN_ROUTE = "/login";
